/**
 * Sanitizes a string to be used as an S3 key.
 * Replaces spaces with underscores and removes characters that are not
 * alphanumeric, underscores, hyphens, or periods.
 */
export const sanitizeS3Key = (key: string): string => {
  return key
    .replaceAll(/\s+/g, '_') // Replace spaces with underscores
    .replaceAll(/[^a-zA-Z0-9._-]/g, '_'); // Remove non-S3-safe characters
};

/**
 * Generates a timestamped S3 key for a reel or thumbnail.
 * Example: images/{uid}/reels/test_1711204800.mp4
 */
export const generateS3Key = (
  uid: string, 
  filename: string, 
  type: 'reels' | 'thumbnails' | 'videos' | 'additional-images',
  folder: 'reels' | 'videos' = 'reels'
): string => {
  const sanitizedFilename = sanitizeS3Key(filename);
  const timestamp = Math.floor(Date.now() / 1000);
  const extension = sanitizedFilename.split('.').pop() || '';
  const nameWithoutExtension = sanitizedFilename.substring(0, sanitizedFilename.lastIndexOf('.')) || sanitizedFilename;
  
  if (type === 'thumbnails') {
    return `images/${uid}/${folder}/thumbnail/${nameWithoutExtension}_${timestamp}.${extension || 'jpg'}`;
  }

  if (type === 'additional-images') {
    return `images/${uid}/${folder}/additionalImages/${nameWithoutExtension}_${timestamp}.${extension}`;
  }

  return `images/${uid}/${folder}/${nameWithoutExtension}_${timestamp}.${extension}`;
};
